module.exports = __webpack_public_path__ + "static/media/icon-win.3f19ad73.svg";